/* Joyce Giraud Beauty — "Complete your ritual" cart upsell (vanilla JS).
   Fills the shells rendered by snippets/cart-upsell.liquid in the cart drawer
   (#jgcu-drawer) and on the /cart page (#jgcu-page).
   - Reads the live cart from /cart.js and product data from /products/<handle>.js.
   - Never suggests a family already in the cart (any tier or handle).
   - "+ ADD" adds the family's one-time variant (quantity 1, no selling plan);
     if a family has no purchasable one-time variant it shows "VIEW" instead.
   - After an add, the drawer refreshes through the theme's own
     window.BloomCart.refresh(); the /cart page reloads (its normal update path).
   Existing cart code is not modified: the drawer list is watched with a
   MutationObserver so the upsell recalculates whenever the theme re-renders. */
(function () {
  'use strict';
  if (window.JGCartUpsell) return;

  /* show: product the card displays and links to.
     buy: product whose one-time variant "+ ADD" puts in the bag.
     members: every handle of the family (incl. parked/copy tiers), used to
     decide whether the family is already in the cart. */
  var FAMILIES = {
    hsp: {
      show: 'ultimate-hair-strength-pro-supplements',
      buy: 'ultimate-hair-strength-pro-supplements-30-days-parked',
      members: ['ultimate-hair-strength-pro-supplements', 'ultimate-hair-strength-pro-supplements-60-day-parked', 'ultimate-hair-strength-pro-supplements-30-days-parked']
    },
    gummies: {
      show: 'ultimate-beauty-gummies-90-days',
      buy: 'ultimate-beauty-gummies-copy',
      members: ['ultimate-beauty-gummies-90-days', 'ultimate-beauty-gummies-60-days-1', 'ultimate-beauty-gummies-copy', 'ultimate-beauty-gummies']
    },
    sleep: {
      show: 'ultimate-beauty-sleep-transform-your-skin-while-you-sleep',
      buy: 'ultimate-beauty-sleep-transform-your-skin-while-you-sleep',
      members: ['ultimate-beauty-sleep-transform-your-skin-while-you-sleep', 'ultimate-beauty-sleep-30-days-copy', 'ultimate-beauty-sleep-30-days-copy-1']
    },
    detox: {
      show: 'keratin-therapy-scalp-detox',
      buy: 'keratin-therapy-scalp-detox',
      members: ['keratin-therapy-scalp-detox', 'keratin-therapy-scalp-detox-copy', 'keratin-therapy-scalp-detox-60-days-copy']
    },
    rog: {
      show: 'the-root-of-goodness-3-piece-system',
      buy: 'the-root-of-goodness-3-piece-system',
      members: ['the-root-of-goodness-3-piece-system']
    },
    mask: {
      show: '2-minute-miracle-hair-mask',
      buy: '2-minute-miracle-hair-mask',
      members: ['2-minute-miracle-hair-mask', '2-minute-miracle-hair-mask-double-size']
    },
    pure4: {
      show: 'miracle-oil-blend',
      buy: 'miracle-oil-blend',
      members: ['miracle-oil-blend']
    }
  };
  var PAIRS = {
    hsp: ['detox', 'gummies'],
    gummies: ['sleep', 'hsp'],
    sleep: ['gummies', 'hsp'],
    detox: ['hsp', 'rog']
  };
  var BEST_SELLERS = ['hsp', 'detox', 'gummies', 'rog', 'mask', 'pure4', 'sleep'];
  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
  var ERROR_TEXT = 'Sorry, this item could not be added. Please try again.';

  /* ── Helpers ── */
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; });
  }
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = getJSON('/products/' + handle + '.js').catch(function () { return null; });
    }
    return productCache[handle];
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Same day-count cleanup as snippets/bloom-card-clean-title.liquid */
  function cleanTitle(t) {
    return String(t || '').replace(/\s*[-\/]?\s*\b(30|60|90)[\s-]DAYS?\s*$/i, '').trim();
  }
  /* Link URLs for the four standalone families, rendered by
     snippets/standalone-product-url.liquid into [data-jgcu-urls] */
  var standaloneUrls = null;
  function standaloneUrl(handle) {
    if (!standaloneUrls) {
      standaloneUrls = {};
      try {
        var el = document.querySelector('[data-jgcu-urls]');
        if (el) standaloneUrls = JSON.parse(el.textContent) || {};
      } catch (e) { standaloneUrls = {}; }
    }
    return standaloneUrls[handle] || '';
  }

  function sizedImage(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function familyOf(handle) {
    for (var k in FAMILIES) {
      if (FAMILIES[k].members.indexOf(handle) > -1) return k;
    }
    return null;
  }

  /* Ordered, de-duplicated family keys for this cart (families already in
     the cart removed). Pairings first, then the Best Sellers order. */
  function candidateKeys(cart) {
    var inCart = {};
    cart.items.forEach(function (item) {
      var k = familyOf(item.handle);
      if (k) inCart[k] = true;
    });
    var out = [];
    function push(k) { if (!inCart[k] && out.indexOf(k) === -1) out.push(k); }
    cart.items.forEach(function (item) {
      var k = familyOf(item.handle);
      (k && PAIRS[k] ? PAIRS[k] : BEST_SELLERS).forEach(push);
    });
    BEST_SELLERS.forEach(push);
    return out;
  }

  /* Card data for one family, or null if it must not be suggested. */
  function familyCard(key) {
    var f = FAMILIES[key];
    return Promise.all([getProduct(f.show), f.buy === f.show ? null : getProduct(f.buy)]).then(function (r) {
      var show = r[0];
      var buy = f.buy === f.show ? show : r[1];
      if (!show || !show.available) return null; // unavailable or sold out: never suggest
      var variant = null;
      if (buy) {
        variant = buy.variants.filter(function (v) { return v.available && !v.requires_selling_plan; })[0] || null;
      }
      return {
        key: key,
        title: cleanTitle(show.title),
        url: standaloneUrl(show.handle) || show.url || ('/products/' + show.handle),
        image: sizedImage(show.featured_image, 240),
        variantId: variant ? variant.id : null,
        price: variant ? variant.price : null,
        compare: variant && variant.compare_at_price > variant.price ? variant.compare_at_price : null
      };
    });
  }

  function cardHTML(c) {
    var price = c.price != null
      ? '<p class="jgcu__price"><span class="jgcu__now">' + money(c.price) + '</span>'
        + (c.compare ? ' <s class="jgcu__was">' + money(c.compare) + '</s>' : '') + '</p>'
      : '';
    var action = c.variantId
      ? '<button type="button" class="jgcu__add" data-jgcu-add="' + c.variantId + '" aria-label="Add ' + esc(c.title) + ' to your bag">+ ADD</button>'
      : '<a class="jgcu__add jgcu__add--view" href="' + esc(c.url) + '" aria-label="View ' + esc(c.title) + '">VIEW</a>';
    return '<li class="jgcu__item" data-jgcu-family="' + c.key + '">'
      + '<a class="jgcu__media" href="' + esc(c.url) + '" tabindex="-1" aria-hidden="true">'
      + (c.image ? '<img src="' + esc(c.image) + '" alt="" width="120" height="120">' : '')
      + '</a>'
      + '<div class="jgcu__info">'
      + '<a class="jgcu__name" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'
      + price
      + '</div>'
      + action
      + '</li>';
  }

  /* ── Render one block ── */
  var tokens = {};
  function update(block) {
    if (!block) return;
    var ctx = block.getAttribute('data-jgcu-context');
    var token = (tokens[ctx] || 0) + 1;
    tokens[ctx] = token;
    getJSON('/cart.js').then(function (cart) {
      if (tokens[ctx] !== token) return null;
      if (!cart || !cart.item_count) { block.hidden = true; return null; }
      var max = (ctx === 'drawer' && MOBILE.matches) ? 2 : 3;
      return Promise.all(candidateKeys(cart).map(familyCard)).then(function (cards) {
        if (tokens[ctx] !== token) return;
        cards = cards.filter(Boolean).slice(0, max);
        var list = block.querySelector('[data-jgcu-list]');
        if (!cards.length || !list) { block.hidden = true; return; }
        list.innerHTML = cards.map(cardHTML).join('');
        block.hidden = false;
      });
    }).catch(function () { /* leave the block as it is */ });
  }

  /* ── Add (one-time variant, quantity 1, no selling plan) ── */
  var adding = false;
  function showError(block, show) {
    var err = block && block.querySelector('[data-jgcu-error]');
    if (!err) return;
    err.textContent = show ? ERROR_TEXT : '';
    err.hidden = !show;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jgcu-add]');
    if (!btn) return;
    e.preventDefault();
    if (adding || btn.disabled) return;
    adding = true;
    var block = btn.closest('.jgcu');
    var ctx = block ? block.getAttribute('data-jgcu-context') : 'drawer';
    showError(block, false);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.textContent = 'ADDING';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-jgcu-add'), 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      if (ctx === 'page') { window.location.reload(); return; }
      if (window.BloomCart && typeof window.BloomCart.refresh === 'function') {
        return window.BloomCart.refresh();
      }
      update(block);
    }).then(function () {
      if (ctx !== 'page') adding = false;
    }).catch(function () {
      adding = false;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
      btn.textContent = '+ ADD';
      showError(block, true);
    });
  });

  /* ── Wiring ── */
  function init() {
    var drawerBlock = document.getElementById('jgcu-drawer');
    var pageBlock = document.getElementById('jgcu-page');
    var drawer = document.getElementById('bloom-cart-drawer');
    var items = document.getElementById('bloom-cart-items');

    if (drawerBlock && drawer && items && window.MutationObserver) {
      var timer = null;
      var schedule = function () {
        if (!drawer.classList.contains('is-open')) return;
        clearTimeout(timer);
        timer = setTimeout(function () { update(drawerBlock); }, 60);
      };
      /* bloom-cart.js re-renders the list after every open, add, +/- and remove */
      new MutationObserver(schedule).observe(items, { childList: true });
      new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      if (drawer.classList.contains('is-open')) schedule();
    }
    if (pageBlock) update(pageBlock);
  }

  window.JGCartUpsell = { update: function () {
    update(document.getElementById('jgcu-drawer'));
    update(document.getElementById('jgcu-page'));
  } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
